import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_50: FaireProductEntity = {
  token: "legacy_prod_abbott-50",
  type: "product",
  name: "Nutcracker Pedestal Cake Plate (Clearance)",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8246caf59b8e5382c72cb300834a71c09efbbfff0b1d23d729d50176df3fe996.jpeg",
  priceDollars: 22,
  msrpDollars: 44,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
